import { useState } from "react";
import "./App.css";
import "./styles/Packages.css";
import Packages from "./Pages/Packages";
import PackageDetail from "./Pages/PackageDetail";
import Home from "./Pages/Home";

function App() {
  const [currentPage, setCurrentPage] = useState("packages");
  const [selectedPackage, setSelectedPackage] = useState(null);

  const packageData = {
    interior: {
      title: "The Interior Package",
      price: "Starting at $120",
      duration: "Duration: 2.5 hours",      services: ["Thorough Vacuum on Seats & Floors", "Tornado Blast for Hard-to-Reach Areas", "Decontaminate Vinyl/Plastics & Leather", "Full Clean of All Mats", "Windows & Mirrors Cleaned", ],
      description: "Our Interior Package is designed to restore your car's interior to showroom condition. Using professional-grade equipment and techniques, we deep clean every surface, removing stubborn stains and eliminating odors.",
      additionalInfo: "For vehicles with excessive pet hair or severe stains, additional charges may apply. Please inform us of any specific areas of concern before the service.",
      calendarLink: "https://cal.com/brotdetailing/interior?nxtPuser=brotdetailing",
    },
    exterior: {
      title: "The Exterior Package",
      price: "Starting at $90",
      duration: "Duration: 1 hours",
      services: ["Wipe Down of Door Jams", "Full Pressure Wash Rinse", "Rims, Tires, & Exhaust Cleaning", "Pre-Wash Removing Bugs & Contaminants", "Foam Bath Including Gas Cap", "Complete Dry-Off", "Window & Glass Treatment", "Apply Tire Shine"],
      description: "Our Exterior Package provides a comprehensive clean for your vehicle's exterior, ensuring every surface shines. We use professional techniques and products to protect your car's finish.",
      additionalInfo: "Heavy contamination or excessive bug/tar removal may require additional time and cost.",
      calendarLink: "https://cal.com/brotdetailing/exterior?nxtPuser=brotdetailing",
    },
    basic: {
      title: "The Basic Package",
      price: "Starting at $179",
      duration: "Duration: 3.5 hours",
      services: ["Thorough Vacuum on Seats & Floors", "Tornador Blast for Hard-to-Reach Areas", "Decontaminate Vinyl/Plastics & Leather", "Full Clean of All Mats", "Windows & Mirrors Cleaned", " ", "Wipe Down of Door Jambs", "Full Pressure Wash Rinse", "Rims, Tires, & Exhaust Cleaning", "Pre-Wash Removing Bugs & Contaminants", "Foam Bath Including Gas Cap", "Complete Dry-Off", "Window & Glass Treatment", "Apply Tire Shine"],
      description: "The Basic Package combines our Interior and Exterior packages for a complete vehicle transformation. Perfect for regular maintenance and general cleaning needs.",
      additionalInfo: "This package provides the best value for complete car care.",
      calendarLink: "https://cal.com/brotdetailing/basic?nxtPuser=brotdetailing",
    },
    deluxe: {
      title: "The Deluxe Package",
      price: "Starting at $199",
      duration: "Duration: 4 hours",
      services: [
        "Thorough Vacuum on Seats & Floors",
        "Tornador Blast for Hard-to-Reach Areas",
        "Decontaminate Vinyl/Plastics & Leather",
        "Full Clean of All Mats",
        "Windows & Mirrors Cleaned",        " ",
        { name: "*Apply Shine on Rubber Mats", isHeader: true },
        { name: "*Custom Carpet Designs", isHeader: true },
        { name: "*Remove any Sticker or Tape Residue", isHeader: true },
        "Wipe Down of Door Jambs",
        "Full Pressure Wash Rinse",
        "Rims, Tires, & Exhaust Cleaning",
        "Pre-Wash Removing Bugs & Contaminants",
        "Foam Bath Including Gas Cap",
        "Complete Dry-Off",
        "Window & Glass Treatment",
        "Apply Tire Shine",
        { name: "*1 Month Ceramic Wax (Protection, Hydrophobic Effects, and Shine)", isHeader: true }
      ],
      description: "Our premium package includes everything in the Basic Package plus advanced protection treatments. The ceramic wax provides lasting protection and an amazing shine.",
      additionalInfo: "The ceramic coating helps protect against environmental damage and makes future cleaning easier.",
      calendarLink: "https://cal.com/brotdetailing/deluxe?nxtPuser=brotdetailing",
    },
    maintenance: {
      title: "Maintenance",
      price: "Special Rates",
      duration: "Duration: Varies",
      services: ["Unlock exclusive discounts based on how many cars you include and how often you schedule, perfect for families or collectors looking to maintain pristine vehicles hassle-free. After just one detail, our Maintenance Package ensures your car stays protected year-round with regular wax reapplications to guard against UV damage, enhance hydrophobic properties for rain defense, and deliver a lasting, shine. You'll never need another full detail again.", "Already set up clients can schedule their next appointment by clicking below."],
      description: "Exclusive package for our regular customers, offering specialized services and preferential rates. We tailor the service to your specific needs and maintenance schedule.",
      additionalInfo: "Please contact us directly to discuss your maintenance needs and schedule.",
      calendarLink: "https://cal.com/brotdetailing/maintenance-customers-only?nxtPuser=brotdetailing&duration=240",
    },
  };

  return (
    <div className="App">
      {currentPage === "home" && <Home setShowPackages={setCurrentPage} />}
      {currentPage === "packages" && <Packages setShowPackages={setCurrentPage} setSelectedPackage={setSelectedPackage} />}
      {currentPage === "packageDetail" && selectedPackage && <PackageDetail setShowPackages={setCurrentPage} packageData={packageData[selectedPackage]} />}
    </div>
  );
}

export default App;
